export type SurveyLanguage = 'en' | 'zh'

export interface SurveyOption {
  id: string
  en: string
  zh: string
}

export const NIDLP_SURVEY_OPTION_COLUMNS = {
  left: ['saudi_coffee', 'photo_booth', 'pavilion_design', 'calligraphy'],
  right: ['vr_experience', 'investment_screen', 'co_exhibitor', 'workshops'],
} as const

export const NIDLP_SURVEY_OPTIONS: SurveyOption[] = [
  { id: 'saudi_coffee', en: 'Saudi Coffee Experience', zh: '沙特咖啡体验' },
  { id: 'vr_experience', en: 'VR Experience', zh: 'VR 体验' },
  { id: 'photo_booth', en: 'Photo Booth', zh: '拍照亭' },
  { id: 'investment_screen', en: 'Interactive Investment screen', zh: '互动投资屏幕' },
  { id: 'pavilion_design', en: 'Pavilion Design & Architecture', zh: '展馆设计与建筑' },
  { id: 'co_exhibitor', en: 'Co-Exhibitor Area', zh: '联合参展商区域' },
  { id: 'calligraphy', en: 'Arabic Calligraphy Experience', zh: '阿拉伯书法体验' },
  { id: 'workshops', en: 'Workshops & Presentations', zh: '工作坊与演讲' },
]

export const NIDLP_SURVEY_COPY = {
  welcomeTitle: { en: 'Welcome', zh: '欢迎' },
  welcomeSubtitle: {
    en: 'Thank You for Visiting Us. Tell us about your experience.',
    zh: '感谢您莅临参观。请告诉我们您的体验。',
  },
  startSurvey: { en: 'Start survey', zh: '开始问卷' },
  footer: { en: 'We value your feedback', zh: '我们重视您的反馈' },
  question: {
    en: 'What was the most memorable part of your visit to the Saudi Pavilion? (Select all that apply)',
    zh: '您在参观沙特馆期间，最令您印象深刻的部分是什么？（可多选）',
  },
  submitSurvey: { en: 'Submit Survey', zh: '提交问卷' },
  submitAndExplore: {
    en: 'Submit and Explore Investment Opportunities',
    zh: '提交并探索投资机会',
  },
  successTitle: { en: 'Thank you ! Survey Submitted !', zh: '谢谢您！问卷提交成功！' },
  scanQr: {
    en: 'Scan to explore Investment Opportunities',
    zh: '扫码探索投资机会',
  },
  selectAtLeastOne: {
    en: 'Please select at least one option.',
    zh: '请至少选择一项。',
  },
} as const

export function t(
  record: Record<SurveyLanguage, string>,
  language: SurveyLanguage,
): string {
  return record[language]
}
